import { apiRequest } from "./client";

export const adminApi = {
  overview() {
    return apiRequest("/admin/overview");
  },
  activity(params = {}) {
    return apiRequest("/admin/activity", { params });
  },
  activitySummary(hours = 24) {
    return apiRequest("/admin/activity/summary", { params: { hours } });
  },
  activityJourneys(params = {}) {
    return apiRequest("/admin/activity/journeys", { params });
  },
  activityAnalytics(filters = 30) {
    const params = typeof filters === "number" ? { days: filters } : filters;
    return apiRequest("/admin/activity/analytics", { params });
  },
  integrityAudit() {
    return apiRequest("/admin/integrity-audits/latest");
  },
  commandCenterSummary(params = {}) {
    return apiRequest("/admin/command-center/summary", { params });
  },
  commandCenterProjects(params = {}) {
    return apiRequest("/admin/command-center/projects", { params });
  },
  commandCenterProject(projectId, params = {}) {
    return apiRequest(`/admin/command-center/projects/${encodeURIComponent(projectId)}`, { params });
  },
  commandCenterAdoption(params = {}) {
    return apiRequest("/admin/command-center/adoption", { params });
  },
  commandCenterIntegrations(params = {}) {
    return apiRequest("/admin/command-center/integrations", { params });
  },
  pushStatus() {
    return apiRequest("/admin/push");
  },
  subscribePush(subscription, preferences = {}) {
    return apiRequest("/admin/push/subscribe", {
      method: "POST",
      body: JSON.stringify({ subscription, preferences }),
    });
  },
  unsubscribePush(endpoint) {
    return apiRequest("/admin/push/subscribe", {
      method: "DELETE",
      body: JSON.stringify({ endpoint }),
    });
  },
  testPush(payload = {}) {
    return apiRequest("/admin/push/test", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
